import { CopyrightPage, CopyrightPageQuery } from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_COPYRIGHT_PAGE } from '@/graphql/queries/copyright/copyright';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<CopyrightPageQuery>({
      query: QUERY_COPYRIGHT_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.copyrightPage?.data?.attributes as CopyrightPage,
    error,
  };
};
